import type { FinanceLedgerInterval, FinanceRate } from "@/lib/api";

/**
 * 1 単位あたりの粗利と粗利率 ((単価 − 原価) ÷ 単価)。原価が未設定なら両方 null、
 * 単価が 0 (無償のメータ) なら率は定義できないので null。
 */
export function grossMargin(rate: FinanceRate): { profit: number | null; ratio: number | null } {
	if (rate.unitCostCredits === null) return { profit: null, ratio: null };
	const profit = rate.unitPriceCredits - rate.unitCostCredits;
	return {
		profit,
		ratio: rate.unitPriceCredits === 0 ? null : profit / rate.unitPriceCredits,
	};
}

/** 粗利率の表示。単価の切り上げ端数で 20.0000…% のように桁が伸びないよう小数 1 桁に丸める。 */
export function formatMarginRatio(ratio: number): string {
	return new Intl.NumberFormat("ja-JP", {
		style: "percent",
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	}).format(ratio);
}

export const LEDGER_INTERVALS: readonly { id: FinanceLedgerInterval; label: string }[] = [
	{ id: "daily", label: "日次" },
	{ id: "monthly", label: "月次" },
];
